import config from '../../config/env'
export const data=[
    {
        module1:{
            title:"电子宣传页",
            slogan:'降低企业成本，提升产品关注度',
            src:config.baseUrl+'/hitcloud/home/list/page-1-1.png'
        },
        module2:[{
            title:"产品简介",
            slogan:'电子宣传页，是一种集合图片处理、文案策划、音乐加工、录音解说、视频制作、统计调查、虚拟现实、三维动画等多种技术和表现形式为一体的多媒体广告，它是纸质印刷品的升级版本，它不仅环保，而且还不受时间、空间、地域的限制，以二维码的方式分享，便于消费者阅读，更是便于推广。',
            src:config.baseUrl+'/hitcloud/home/list/page-1-2.png'
        },{
            title:"产品优势",
            slogan:'降低企业的营销物料成本，节约产品宣传页印刷成本，更环保；<br /> 降低了企业培训的成本，新品学习；<br /> 降低了企业销售的人工成本；提高企业的"品牌形象"；<br /> 增强了企业与消费者的互动，使企业时刻了解消费者动向；<br /> 通过电子宣传页，企业可以在线快捷方便投放产品相关信息，直达消费者，1分钟内即可扫码浏览，使信息传播变得方便快捷、精确有效！包括品牌宣传、领导风采、产品资讯、荣誉奖项、营销活动、售后服务等信息。',
            src:config.baseUrl+'/hitcloud/home/list/page-1-3.png'
        }],
        module3:{
            title:'电子宣传页-效果展示',
            src:config.baseUrl+'/hitcloud/home/list/page-1-4.jpg'
        },
        module4:{
            title:'这些企业都在使用',
            src:config.baseUrl+'/hitcloud/home/list/page-1-5.png'
        }
    },
    {
        module1:{
            title:"电子说明书",
            slogan:'低成本、高效率、再营销',
            src:config.baseUrl+'/hitcloud/home/list/page-2-1.png'
        },
        module2:[{
            title:"产品简介",
            slogan:'电子说明书，是一套在线产品信息展示系统。电子说明书解决了传统纸质说明书成本高、难更改、迭代慢的难题，更是顺应了时代趋势，为企业解决了获客成本高，新品推出营销不精准的难题。',
            src:config.baseUrl+'/hitcloud/home/list/page-2-2.png'
        },{
            title:"产品优势",
            slogan:'<strong>低成本、高效率、再营销</strong> 纸质说明书被翻看的几率很低响应环保，绝大多数纸质制品对环境污染巨大，正处于被淘汰的处境；而在移动互联网的今天人们对手机高度依赖，电子说明书使用便捷而且低碳节能，能够有效的帮助企业降低成本实现精准营销；<br /><strong>一型一码认证</strong> 电子说明书提供二维码云平台，扫码后可以获得产品相关信息，潜移默化地在消费者心中树立起品牌形象；<br /> <strong>数据分析</strong> 电子说明书后台包括PV、UV、位置信息等数据，全方位分析和洞察消费者行为； <strong>升级无忧</strong> 电子说明书解决了迭代浪费的苦恼，产品升级只需要在后台适当修改就可以一键发布，无需更多的采购支出。',
            src:config.baseUrl+'/hitcloud/home/list/page-2-3.png'
        }],
        module3:{
            title:'电子说明书-效果展示',
            src:config.baseUrl+'/hitcloud/home/list/page-2-4.jpg'
        },
        module4:{
            title:'这些企业都在使用',
            src:config.baseUrl+'/hitcloud/home/list/page-2-5.png'
        }
    },
    {
        module1:{
            title:"认证及荣誉展示",
            slogan:'提升荣誉曝光量，提升产品信赖度',
            src:config.baseUrl+'/hitcloud/home/list/page-3-1.png'
        },
        module2:[{
            title:"产品简介",
            slogan:'各类国家认证的电子证书模板，可编辑可修改批量化生产，简单操作就可轻松发布，一键生成二维码，便于不同场景不同渠道快速传播。',
            src:config.baseUrl+'/hitcloud/home/list/page-3-2.png'
        },{
            title:"认证及荣誉",
            slogan:'<strong>RoHS证书</strong> 依2019年中国国家市场监管总局发布《市场监管总局关于明确电器电子产品有害物质限制使用合格评定制度"供方符合性标志"的公告》RoHS认证全面实施，明确电器电子产品有害物质限制使用合格评定制度中采用自我声明方式所使用的"供方符合性标志"。<br /><br /> <strong>铜佳品质生活</strong> 铜佳品质生活标签是由国际铜业协会针对日益复杂的家电市场环境，在家电和家居生活产品内推出的铜识别性商标，该标签代表了高品质、高性能、绿色、关爱的优质家电和家居生活产品形象，是连接消费者的桥梁，通过对该标签的推广应用，为消费者选择用铜的高端家电和家居生活产品提供明晰的选择。',
            src:config.baseUrl+'/hitcloud/home/list/page-3-3.png'
        }],
        module3:{
            title:'产品荣誉及认证-效果展示',
            src:config.baseUrl+'/hitcloud/home/list/page-3-4.jpg'
        },
        module4:{
            title:'这些企业都在使用',
            src:config.baseUrl+'/hitcloud/home/list/page-3-5.png'
        }
    },
    {
        module1:{
            title:"问卷调查",
            slogan:'轻松完成市场调查、满意度调查等各类在线问卷调查',
            src:config.baseUrl+'/hitcloud/home/list/page-4-1.png'
        },
        module2:[{
            title:"产品简介",
            slogan:'基于消费者需求问卷调查的"5步6词选优品"，理解翻译消费者需求精准匹配信息，将市场需求结构化、数据化，精准推送、引流到生产企业。',
            src:config.baseUrl+'/hitcloud/home/list/page-4-2.png'
        },{
            title:"产品优势",
            slogan:'通过5-6个生活化场景的简单问题，帮助消费者将真实生活场景中的需求与产品技术特性直接对应，消费者不用再费力理解各类专业术语，只需要说出自己生活化、场景化的需求，平台就可以为消费者提供定制化的产品选购建议。 为消费者精准匹配符合其需求的"领跑者"产品及其他优质产品，助力消费升级。直接根据消费者的回答匹配"领跑者"产品等优质产品链接，进行定制化的优质、绿色消费引导。 对收集到的消费者需求进行数据化、结构化处理，整理出直接来自于消费者的一手、真实的消费需求报告提供给企业。',
            src:config.baseUrl+'/hitcloud/home/list/page-4-3.png'
        }],
        module3:{
            title:'问卷调查-效果展示',
            src:config.baseUrl+'/hitcloud/home/list/page-4-4.jpg'
        },
        module4:{
            title:'这些企业都在使用',
            src:config.baseUrl+'/hitcloud/home/list/page-4-5.png'
        }
    },
    {
        module1:{
            title:"行业报告",
            slogan:'挖掘行业数据价值，洞察精准人群',
            src:config.baseUrl+'/hitcloud/home/list/page-5-1.png'
        },
        module2:[{
            title:"产品简介",
            slogan:'对终端用能产品能效信息和消费者关注度数据进行收集、整理、挖掘和分析，让企业提前洞察产品与市场行业和趋势，从而达到了解市场需求、竞争态势，实时调整市场策略，为企业降本增效，提升企业和产品的竞争力。',
            src:config.baseUrl+'/hitcloud/home/list/page-5-2.png'
        },{
            title:"产品优势",
            slogan:'<strong>消费端动态</strong> 1、消费者喜欢什么？每周扫码量最大的"爆款"有什么特点？<br /> 2、不同的品牌和不同的地域，消费者的喜好和关注度有什么区别？不同特点的产品型号企业应该如何布局？消费者对产品还有哪些隐含的需求？ <strong>企业端动态</strong> 可能即将上市的整体型号数量和分品牌型号数量是多少？ 可能即将上市的型号分别是什么能效等级？可能即将上市的型号还有哪些值得关注的关键指标？ <strong>政府端动态</strong> 1、监管部门有哪些新动作？<br /> 2、帮助企业发现电商平台中存在的非故意的不合规行为，提醒企业及时改正；如果为故意违规行为，则将其作为执法线索提供给监管部门，维护良好市场环境。<br /> 3、梳理市场监管、政策标准新动态，为企业落实相关政策提供参考和协助。',
            src:config.baseUrl+'/hitcloud/home/list/page-5-3.png'
        }],
        module3:{
            title:'行业报告-效果展示',
            src:config.baseUrl+'/hitcloud/home/list/page-5-4.jpg'
        },
        module4:{
            title:'这些企业都在使用',
        }
    },
    {
        module1:{
            title:"客服机器人",
            slogan:'AI赋能，抓住用户每一次访问',
            src:config.baseUrl+'/hitcloud/home/list/page-6-1.png'
        },
        module2:[{
            title:"产品简介",
            slogan:'客服机器人，产品制造企业客户服务的一直都面临着渠道分散，不统一，售后客服投入大、任务重，售后能够快速为销售提供"销售线索"，高效精准的用户调研等问题。智能客服机器人24小时在线客服，寒暄、业务咨询，有效的节省客服人工成本。',
            src:config.baseUrl+'/hitcloud/home/list/page-6-2.png'
        },{
            title:"产品优势",
            slogan:'<span>7*24小时提供服务：</span>可以全年无休，不间断的提供服务，夜间机器人，不再为值夜班而发愁；<br/> <span>全都是金牌客服：</span>每个顾客都可以由金牌客服提供服务，每个顾客都能成为VIP <br/><span>无限接待能力：</span>节假日大促机，机器人无限接待能力，不用再闲时准备忙时用，彻底解决人力成本问题 <br/><span>智能推荐：</span>用户喜欢什么推荐什么，一招解决转化率 <br/><span>运营优化管理：</span>商品活动按需随意变动，第一时间能Get，提高运营效率 <br/><span>人机协同：</span>AI与在线客服系统打通，无缝进行人机配合协同，提升服务整体满意度。',
            src:config.baseUrl+'/hitcloud/home/list/page-6-3.png'
        }],
        module3:{
            title:'客服机器人-效果展示',
            src:config.baseUrl+'/hitcloud/home/list/page-6-4.png'
        },
        module4:{
            title:'这些企业都在使用',
            
        }
    },
    {
        module1:{
            title:"智慧网关",
            slogan:'一型一码精准识别产品型号',
            src:config.baseUrl+'/hitcloud/home/list/page-7-1.png'
        },
        module2:[{
            title:"产品简介",
            slogan:'一型一码精准识别产品型号，数据网关物联网适配，实现多个业务系统互联，实现各个系统之间信息和流程的共享和管理。',
            src:config.baseUrl+'/hitcloud/home/list/page-7-2.png'
        },{
            title:"产品优势",
            slogan:'系统对接：通过数据网关，可将产品数据、外部数据与智能家电系统对接。<br/> 数据导入：通过数据网关，可将产品数据、外部数据导入智能家电系统。',
            src:config.baseUrl+'/hitcloud/home/list/page-7-3.png'
        }],
        module3:{
            title:'智慧网关-效果展示',
            src:config.baseUrl+'/hitcloud/home/list/page-7-4.jpg'
        },
        module4:{
            title:'这些企业都在使用',
            src:config.baseUrl+'/hitcloud/home/list/page-7-5.png'
        }
    }
    
]